export const LanguageConstant =  {
  HR: { id: "hr", name: "common.languages.hr", shortName: "Hrv" },
  EN: { id: "en", name: "common.languages.en", shortName: "Eng" }
};

export const SupportedLanguages = [LanguageConstant.HR, LanguageConstant.EN];
